let getAccessTokenSilently = async () => {
  // Implementation for fetching the token asynchronously
};

export const sec = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func) => (getAccessTokenSilently = func),
};
